import { db } from "./firebase";

export const getUserRef = () => db.collection("users").doc();
export const createUserRef = uid => db.collection("users").doc(uid);
export const setUser = (ref, user) => ref.set(user);
export const createUser = user => db.collection("users").add(user);
